import { createContext, useCallback, useContext, useState } from 'react';
import { ThemeProvider as ThemeProviderStyled } from 'styled-components';
import { darkTheme, lightTheme } from '../styles/theme';

interface ThemeContextInterface {
  theme: 'dark' | 'light';
  changeTheme: (value: 'dark' | 'light') => void;
}

export const ThemeContext = createContext<ThemeContextInterface>(
  {} as ThemeContextInterface,
);

export const ThemeProvider: React.FC = ({ children }) => {
  const [theme, setTheme] = useState<'light' | 'dark'>(() => {
    const getTheme: any = localStorage.getItem('@wakeUp:theme');
    if (getTheme) {
      return getTheme;
    }
    return 'light';
  });

  const handleChangeTheme = useCallback((value: 'dark' | 'light') => {
    setTheme(value);
    localStorage.setItem('@wakeUp:theme', value);
  }, []);

  return (
    <ThemeContext.Provider value={{ theme, changeTheme: handleChangeTheme }}>
      <ThemeProviderStyled theme={theme === 'light' ? lightTheme : darkTheme}>
        {children}
      </ThemeProviderStyled>
    </ThemeContext.Provider>
  );
};

export function useTheme(): ThemeContextInterface {
  const context = useContext(ThemeContext);

  if (!context) {
    throw new Error('useTheme must be used withn an ThemeProvider');
  }

  return context;
}
